import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 静态路由：只保留登录、404和基础Layout
export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        hidden: true
    },

    {
        path: '/404',
        component: () => import('@/views/error/404.vue'),
        hidden: true
    },
    {
        path: '/dragonboat/event/workbench',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '',
                name: 'DragonEventWorkbench',
                component: () => import('@/views/dragonboat/event/workbench.vue'),
                meta: { title: '赛事工作台' }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes
})

export default router